import { useState } from "react";
import { Phone, X } from "lucide-react";

export const FloatingWhatsApp = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <div className="fixed bottom-44 md:bottom-28 right-6 z-50 bg-white rounded-2xl shadow-xl border border-soft p-3 w-56">
          <div className="space-y-2">
            <a
              href="https://wa.me/6282392156538"
              target="_blank"
              rel="noreferrer"
              className="block w-full text-center bg-green-500 text-white rounded-xl py-3 text-sm font-medium hover:bg-green-600 transition"
            >
              WhatsApp Batam
            </a>

            <a
              href="https://wa.me/62811713309"
              target="_blank"
              rel="noreferrer"
              className="block w-full text-center bg-green-500 text-white rounded-xl py-3 text-sm font-medium hover:bg-green-600 transition"
            >
              WhatsApp Palembang
            </a>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        data-testid="floating-whatsapp-btn"
        className="fixed bottom-24 md:bottom-6 right-6 z-50 group"
        aria-label="WhatsApp"
      >
        <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-25" />

        <div className="relative w-14 h-14 md:w-16 md:h-16 rounded-full bg-green-500 text-white grid place-items-center shadow-xl hover:bg-green-600 transition group-hover:scale-105">
          {open ? (
            <X className="w-6 h-6" />
          ) : (
            <Phone className="w-6 h-6 text-white" />
          )}
        </div>
      </button>
    </>
  );
};
